import PropTypes from 'prop-types'
import SDInput from '@/shared/components/SDComponents/SDInput/SDInput'
import { SIZE } from 'baseui/input'
import { useTranslation } from 'react-i18next'

const DevToolsSearch = ({ value, onChange, placeholder }) => {
  const { t } = useTranslation()
  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '500px' }}>
      <SDInput
        id="feedbackSearch"
        size={SIZE.compact}
        type="search"
        placeholder={placeholder || t('devTools:search_feedback_placeholder')}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  )
}

DevToolsSearch.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
}

export default DevToolsSearch
